import React, { useState } from 'react';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      q: 'How do I get quotes?',
      a: 'Getting quotes is simple! Just click the "Get Free Quote" button and fill out our 2-minute form with your moving details. We will then connect you with reliable movers who will provide competitive quotes tailored to your needs.'
    },
    {
      q: 'Is MyMoveAdvisor free to use?',
      a: 'Yes, MyMoveAdvisor is 100% free for customers seeking moving services. Our goal is to help you find the best movers at the best prices without any cost to you.'
    },
    {
      q: 'How long does it take to receive quotes?',
      a: 'Most customers start receiving initial quotes within just a few hours of submitting their request. You can expect to have a range of options to compare within 24 hours.'
    },
    {
      q: 'Are the movers on your platform verified?',
      a: 'Absolutely! We take safety seriously. All movers in our network go through a rigorous verification process, including background checks, license verification, and ongoing performance monitoring based on customer feedback.'
    },
    {
      q: 'Can I compare multiple movers at once?',
      a: 'Yes, that is the core of our service! We provide you with multiple quotes from different verified movers, allowing you to easily compare prices, ratings, and services in one place.'
    },
    {
      q: 'How do I choose the right moving company?',
      a: 'We recommend reviewing each mover\'s rating, reading recent customer reviews, and comparing their specific services (like packing or storage). Our comparison tool makes it easy to see these details side-by-side.'
    },
    {
      q: 'What if my moving dates change?',
      a: 'If your dates change, you can contact your selected mover directly to discuss rescheduling. Most movers are flexible, especially if notified early, but be sure to check their individual cancellation and rescheduling policies.'
    },
    {
      q: 'Are there any hidden fees I should know about?',
      a: 'We encourage transparency. The quotes you receive should be comprehensive. However, we always recommend asking movers about potential extra costs for things like long-carry distances, stairs, or heavy specialty items like pianos.'
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-extrabold text-gray-900 mb-4 tracking-tight">Frequently Asked Questions</h2>
          <div className="w-24 h-1.5 bg-primary mx-auto rounded-full mb-6"></div>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Everything you need to know about the moving process and our platform.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {faqs.map((item, idx) => (
            <div
              key={idx}
              className={`bg-white rounded-xl border transition-all duration-300 overflow-hidden h-fit ${activeIndex === idx
                ? 'border-primary ring-4 ring-primary/5 shadow-lg'
                : 'border-gray-200 hover:border-orange-300 shadow-sm hover:shadow-md'
                }`}
            >
              <button
                onClick={() => toggleFAQ(idx)}
                className="w-full flex items-center justify-between p-5 text-left focus:outline-none group"
              >
                <span className={`text-base font-bold transition-colors duration-300 ${activeIndex === idx ? 'text-primary' : 'text-gray-800'
                  }`}>
                  {item.q}
                </span>
                <div className={`flex-shrink-0 ml-4 w-7 h-7 rounded-full flex items-center justify-center transition-all duration-300 ${activeIndex === idx ? 'bg-primary text-white rotate-180' : 'bg-gray-100 text-gray-500 group-hover:bg-orange-100 group-hover:text-primary'
                  }`}>
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </button>

              <div
                className={`transition-all duration-300 ease-in-out ${activeIndex === idx ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
              >
                <div className="px-5 pb-5 text-gray-600 text-sm leading-relaxed border-t border-gray-50 pt-3">
                  {item.a}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
